// extracted by mini-css-extract-plugin
module.exports = {"Loader":"fastView_Loader__bWH33","Wrapper":"fastView_Wrapper__77dwU"};